/* ------------------------------------------------------------------------------
@name: Gallery (Optimized + Infinite Scroll + Auto Fill)
--------------------------------------------------------------------------------- */

// --- variables
import { API_URL } from "variables";

// --- utilities
import { HttpRequest, SweetAlert, FormatDate } from "utilities";

const Gallery = (() => {
  let debounceTimer = null;

  // ✅ pagination state
  let offset = 0;
  let limit = 20;
  let isLoading = false;
  let isLastPage = false;

  /* =========================
    RENDER
  ========================= */
  const renderGallery = (data, reset = false) => {
    let html = "";

    if (reset) {
      $(".js-gallery-list").html("");
    }

    if (data && data.length > 0) {
      data.forEach((item) => {
        html += `
          <div class="gallery-item">
            <div class="gallery-box js-gallery-preview"
                data-id="${item.id}"
                data-order-id="${item.order_id}"
                data-img="${item.photo}"
                data-title="${item.order_code}"
                data-date="${item.inbound_date}"
                data-time="${item.inbound_time}">

              <img class="gallery-img"
                   src="${item.photo}"
                   loading="lazy"
                   alt="${item.order_code}">

              <button class="gallery-delete js-delete-data" data-id="${item.id}">
                <i class="ph ph-trash"></i>
              </button>
            </div>
          </div>
        `;
      });

      $(".js-gallery-list").append(html);
    } else if (reset) {
      $(".js-gallery-list").html(`<p class="text-center">No data found</p>`);
    }
  };

  const renderSkeleton = () => {
    let html = "";

    for (let i = 0; i < 12; i++) {
      html += `
        <div class="gallery-item skeleton">
          <div class="gallery-box">
            <div class="gallery-img skeleton-img"></div>
          </div>
        </div>
      `;
    }

    $(".js-gallery-list").html(html);
  };

  const renderLoading = () => {
    $(".js-gallery-list").append(`
      <div class="text-center py-3 js-loading-more">
        Loading more...
      </div>
    `);
  };

  const removeLoading = () => {
    $(".js-loading-more").remove();
  };

  /* =========================
    AUTO LOAD FIX (IMPORTANT)
  ========================= */
  const checkAutoLoad = () => {
    const docHeight = $(document).height();
    const windowHeight = $(window).height();

    if (docHeight <= windowHeight + 50 && !isLastPage && !isLoading) {
      handleGetData();
    }
  };

  /* =========================
    FETCH DATA
  ========================= */
  const handleGetData = (reset = false) => {
    if (isLoading) return;

    // ✅ RESET STATE
    if (reset) {
      offset = 0;
      isLastPage = false;
      renderSkeleton();
    } else {
      if (isLastPage) return;
      renderLoading();
    }

    isLoading = true;

    const search = $("#search").val();
    const _date = $("#dateRange").val();
    const _type = $("#type").val();

    let formData = new FormData();
    formData.append("search", search || "");
    formData.append("limit", limit);
    formData.append("offset", offset);
    formData.append("type", _type);

    // ✅ date filter
    if (_date && _date.length > 0) {
      const range = FormatDate.range(_date);
      formData.append("start_date", range.startDate || "");
      formData.append("end_date", range.endDate || range.startDate || "");
    }

    const response = HttpRequest.custom({
      url: API_URL.galleryGet,
      method: "POST",
      data: formData,
    });

    // ✅ ALWAYS remove loading
    removeLoading();

    if (response.code === 200) {
      const data = response.data || [];
      const meta = response.meta || {};

      // ✅ clear skeleton on reset
      if (reset) {
        $(".js-gallery-list").html("");
      }

      // ✅ SET TOTAL (IMPORTANT)
      if (reset && typeof meta.total !== "undefined") {
        $(".js-total-gallery").text(new Intl.NumberFormat().format(meta.total));
      }

      // ✅ RENDER DATA
      renderGallery(data, false);

      // ✅ UPDATE PAGINATION
      offset += limit;

      // ✅ USE BACKEND FLAG (BEST PRACTICE)
      if (!meta.has_more) {
        isLastPage = true;
      }

      // ✅ EMPTY STATE
      if (reset && data.length === 0) {
        $(".js-gallery-list").html(`<p class="text-center">No data found</p>`);
      }

      // 🔥 AUTO LOAD IF PAGE NOT FULL
      setTimeout(() => {
        checkAutoLoad();
      }, 100);
    } else {
      SweetAlert.config(response.message, "error");
    }

    isLoading = false;
  };

  /* =========================
    SCROLL
  ========================= */
  const handleScroll = () => {
    $(window).on("scroll", () => {
      if (isLoading || isLastPage) return;

      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const docHeight = $(document).height();

      if (scrollTop + windowHeight >= docHeight - 200) {
        handleGetData();
      }
    });
  };

  /* =========================
    SEARCH
  ========================= */
  const handleSearch = () => {
    $("body").on("keyup", "#search", () => {
      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
        handleGetData(true);
      }, 400);
    });
  };

  /* =========================
    DATE FILTER
  ========================= */
  const handleDate = () => {
    $("body").on("change", "#dateRange", () => {
      handleGetData(true);
    });
  };

  /* =========================
    TYPE FILTER
  ========================= */
  const handleType = () => {
    $("body").on("change", "#type", () => {
      handleGetData(true);
    });
  };

  /* =========================
    DELETE
  ========================= */
  const handleDeleteData = () => {
    $("body").on("click", ".gallery-delete, .btn-delete-preview", function (e) {
      e.stopPropagation();

      const id = $(this).data("id");
      if (!id) return;

      swal({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger m-l-10",
        buttonsStyling: false,
      }).then(() => {
        let formData = new FormData();
        formData.append("id", id);

        const response = HttpRequest.custom({
          url: API_URL.galleryDelete,
          method: "POST",
          data: formData,
        });

        if (response.code === 200) {
          swal("Deleted!", response.message, "success");
          $("#orderPhotoPreviewModal").modal("hide");

          handleGetData(true);
        } else {
          swal("Failed!", response.message, "error");
        }
      });
    });
  };

  /* =========================
    PREVIEW
  ========================= */
  const handlePreview = () => {
    $(document).on("click", ".js-gallery-preview", function () {
      const id = $(this).data("id");
      const orderId = $(this).data("order-id");
      const img = $(this).data("img");
      const title = $(this).data("title");
      const date = $(this).data("date");
      const time = $(this).data("time");

      const inboundTitle = FormatDate.inboundFormat(date, time);

      $("#orderPhotoPreviewImg").attr("src", img);
      $(".js-order-title").text(title || "-");
      $(".js-order-title").attr("data-id", orderId);
      $(".js-order-photo-preview-date").text(inboundTitle || "");
      $("#orderPhotoPreviewModal .btn-delete-preview").attr("data-id", id);

      $("#orderPhotoPreviewModal").modal("show");
    });
  };

  /* =========================
    INIT
  ========================= */
  const init = () => {
    if ($(".js-gallery-list").length) {
      handleGetData(true); // first load
      handleScroll();
      handleSearch();
      handleDate();
      handleType();
      handlePreview();

      // 🔥 IMPORTANT: auto trigger if short content
      setTimeout(() => {
        checkAutoLoad();
      }, 300);
    }

    handleDeleteData();
  };

  return {
    init,
  };
})();

export default Gallery;
